import { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Divider, Flex, Form, Input, Row, Select } from "antd";

export default function RenderSelect(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;
	const form = Form.useFormInstance();
	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const baseOptions = useMemo(
		() =>
			form_question_options
				.filter((x) => !x.is_other)
				.map((item, index) => ({
					key: item.id ?? index,
					value: item.option,
					label: item.option,
				})),
		[form_question_options],
	);
	const [customOptions, setCustomOptions] = useState([]);
	const options = useMemo(
		() => [...baseOptions, ...customOptions],
		[baseOptions, customOptions],
	);
	const [otherValue, setOtherValue] = useState("");

	let findOther = form_question_options.find((option) => option.is_other);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
								{description && (
									<div className="description">{description}</div>
								)}
							</Col>
						</Row>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<RenderSelectField
									fieldName={`${newNamePath}_set_${idx}`}
									required={required}
									options={options}
									findOther={findOther}
									otherValue={otherValue}
									setOtherValue={setOtherValue}
									form={form}
									setOptions={setCustomOptions}
								/>
							</Col>
						</Row>
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<RenderSelectField
					fieldName={newNamePath}
					required={required}
					options={options}
					findOther={findOther}
					otherValue={otherValue}
					setOtherValue={setOtherValue}
					form={form}
					setOptions={setCustomOptions}
				/>
			</Col>
		</Row>
	);
}

const RenderSelectField = (props) => {
	const {
		fieldName,
		required,
		options,
		findOther,
		otherValue,
		setOtherValue,
		form,
		setOptions,
	} = props;

	return (
		<Form.Item
			name={fieldName}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<Select
				placeholder="Select an answer"
				size="large"
				allowClear
				showSearch
				optionFilterProp="label"
				virtual
				listHeight={256}
				options={options}
				popupRender={
					findOther
						? (menu) => (
								<>
									{menu}
									<Divider style={{ margin: "5px 0" }} />
									<Flex style={{ padding: "0 8px 4px" }}>
										<Input
											placeholder="Add new option"
											value={otherValue}
											onChange={(e) => setOtherValue(e.target.value)}
											onKeyDown={(e) => e.stopPropagation()}
										/>
										<Button
											type="text"
											icon={<FontAwesomeIcon icon={faPlus} />}
											onClick={() => {
												if (otherValue.trim()) {
													setOptions((prevOptions) => [
														...prevOptions,
														{
															key: prevOptions.length,
															value: otherValue,
															label: otherValue,
														},
													]);

													form.setFieldValue(fieldName, otherValue);

													setOtherValue("");
												}
											}}
										/>
									</Flex>
								</>
						  )
						: undefined
				}
			/>
		</Form.Item>
	);
};
